<div [class]="'flex flex-col mt-(--space-4) ' + gapClass">
  <p-skeleton width="10%" height="2rem" />
  @for (item of skeletonItems; track $index; let i = $index) {
    <p-skeleton width="50%" height="3rem" [style.opacity]="getSkeletonOpacity(i)" />
  }
</div>
